import Component from '@glimmer/component';
import dateFormat from 'garaje/helpers/date-format';
import Entry from 'garaje/models/entry';
import type Invite from 'garaje/models/invite';
import { DEFAULT_TIMEZONE } from 'garaje/utils/date-fns-tz-utilities';
import { reads } from 'macro-decorators';

interface ReservationStartTimeColumnSignature {
  Args: {
    content: Entry | Invite;
    fullDate?: boolean;
    timezone?: string;
  };
  Element: HTMLDivElement;
}

export default class ReservationStartTimeColumn extends Component<ReservationStartTimeColumnSignature> {
  @reads('args.content.location.timezone', DEFAULT_TIMEZONE) declare locationTimezone: string;

  get reservationStartTime(): Date | null {
    const { content } = this.args;
    if (content instanceof Entry) {
      return (content.signedInAt as Date | null) ?? null;
    }
    return (content.expectedArrivalTime as Date | null) ?? null;
  }

  get formattedTime(): string | null {
    const date = this.reservationStartTime;
    if (!date) return null;
    const formatStr = this.args.fullDate ? 'MMM d, yyyy - h:mm aaa' : 'h:mm aaa';
    const timezone = this.args.timezone ?? this.locationTimezone;
    return dateFormat(date, formatStr, { timezone });
  }

  <template>
    <div
      data-test-reservation-start-time-cell
      class="table-cell border-b align-top pl-2 pt-6 text-carbon-50"
      ...attributes
    >
      {{#if this.formattedTime}}
        {{this.formattedTime}}
      {{/if}}
    </div>
  </template>
}
